module.exports = __webpack_public_path__ + "img/collection-memoireRingsSlim.c39a20b.jpg";